// extracted by mini-css-extract-plugin
export default {"filterWrapper":"FilterWords_filterWrapper__TAdnx"};